import { Card, Carousel } from "antd";
import donCflCover from "../../assets/images/2023-12/don-cfl.png";
import bannerAlexBaham from "../../assets/images/banner-alex-baham-avril-2025.png";
import ceren from "../../assets/images/Centre-Evangelique-de-Reinsertion-des-Enfants-de-Ntolo.png";
import kingPlace from "../../assets/images/ecole-maternelle-bayangam-king-place.png";
import ntoloBiodigesteur from "../../assets/images/Ntolo-Biodigesteur-Hero.jpg";
import "./styles.less";

const { Meta } = Card;

const HomepageSlider = () => {
  return (
    <Carousel autoplay={true} className="homepage-slider">
      <Card
        cover={
          <img
            src={ntoloBiodigesteur}
            alt="Construction d'un biodigesteur à Ntolo"
          />
        }
        className="homepage-slider__card"
      >
        <Meta title="Construction d'un biodigesteur à Ntolo" />
      </Card>
      <Card
        cover={
          <img
            src={bannerAlexBaham}
            alt="Visite de l'association humanitaire pour la promotion des personnes socialement vulnérables"
          />
        }
        className="homepage-slider__card"
      >
        <Meta title="Visite de l'association humanitaire pour la promotion des personnes socialement vulnérables" />
      </Card>
      <Card
        cover={
          <img
            src={kingPlace}
            alt="Inauguration d'une nouvelle balançoire à Bayangam"
          />
        }
        className="homepage-slider__card"
      >
        <Meta title="Inauguration d'une nouvelle balançoire à Bayangam" />
      </Card>
      <Card
        cover={
          <img
            src={ceren}
            alt="Visite du Centre Evangélique de Réinsertion des Enfants de Ntolo"
          />
        }
        className="homepage-slider__card"
      >
        <Meta title="Visite du Centre Evangélique de Réinsertion des Enfants de Ntolo" />
      </Card>
      <Card
        cover={<img src={donCflCover} alt="Don Ordinateurs CFL - 2023" />}
        className="homepage-slider__card"
      >
        <Meta title="Don Ordinateurs CFL - 2023" />
      </Card>
    </Carousel>
  );
};

export default HomepageSlider;
